const win = global as any;
const ua = win.navigator.userAgent.toLowerCase();

export function getDeviceType() {
  const min = Math.min(win.screen.width, win.screen.height);
  if (min < 576) {
    return "Mobile";
  } else if (min < 1080) {
    return "Tablet";
  } else {
    return "PC";
  }
}

export function getPlatform() {
  if (/android/i.test(ua)) {
    return "Android";
  }

  // 检查是否为 iOS 设备（包括 iPhone, iPad, iPod）
  if (/ipad|iphone|ipod/.test(ua) && !win.MSStream) {
    return "IOS";
  }

  return "Unknown";
}

export function getScreen() {
  return [win.screen.width, win.screen.height];
}

const deviceType = getDeviceType();
export const isWeixin = ua.indexOf("micromessenger") !== -1;
export const isMobile = deviceType === "Mobile";
export const isTouch = getPlatform() !== "Unknown";

export const params = new URLSearchParams(win.location.search);